<template>
  <div ui-view="" class="app-body" id="view">
<!--    <page-header title="각 세종 숙소 예약 현황" description="각 세종의 숙소 예약 현황 정보를 표시합니다."></page-header>-->

    <div class="page-body ph-30 book-search">
      <div class="pt-20 pb-20">

        <div class="row" >
          <div class="search-item">
            <div class="input-group">
              <span class="input-group-addon title">기간선택</span>
              <button class="btn btn-m line-2 mr-3 ml-5" @click="changeDatePicker('before')"><i class="icon-arrow-line-left-centered" ></i></button>
              <DatePicker class="form-control"
                          default-panel="date"
                          :append-to-body="false"
                          :popup-style="{ left: 0}"
                          :clearable="false"
                          :editable="true"
                          style="font-size: 12px;"
                          input-class="calendar-input"
                          v-model="fromDate"
                          @change="changeDatePicker('from')"
                          >
                <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
              </DatePicker>
              <span class="input-group-addon" style="color: #222222;"> ~ </span>
              <DatePicker class="form-control"
                          default-panel="date"
                          :append-to-body="false"
                          :popup-style="{ left: 0}"
                          :clearable="false"
                          :editable="true"
                          style="font-size: 12px;"
                          input-class="calendar-input"
                          v-model="toDate"
                          @change="changeDatePicker('to')"
                          >
                <i slot="icon-calendar" class="icon-calendar" style="color: #222; cursor: pointer"></i>
              </DatePicker>
              <button class="btn btn-m line-2 ml-3" @click="changeDatePicker('after')"><i class="icon-arrow-line-right-centered" ></i></button>
              <button class="btn btn-md line-2 ml-3" @click="changeDatePicker('now')">현재</button>
            </div>
          </div>
        </div>
      </div>

      <div class="row mb-10" style="float: right;">
        <div class="label-group">
          <book-status-tag statusStr="예약대기/완료" bgColor="#03C75A" />
          <book-status-tag statusStr="예약가능" bgColor="#f6f7f8" />
          <book-status-tag statusStr="예약불가" bgColor="#C8C8C8" />
        </div>
      </div>
      <!-- 세로 라인이 있는 경우 tbl 영역에 tbl-type2 클래스 추가 -->
      <table class="tbl tbl-type2 ndk-v2">
        <thead class="no-drag">
          <tr class="">
            <CalendarHeader width="200px" thText="" />
            <CalendarHeader v-for="(date, index) in dateArr" width="auto" :thText="getThText(date)"/>
          </tr>
        </thead>

        <tbody>

        <template v-for="(floor, index) in floors">
          <tr class="bg_highlight_type2">
            <td :colspan="dateArr.length+1">
              <div class="td-box">
                <span class="td-text text-right" style="font-weight: lighter; margin-left: 20px;">STAY {{floor}}</span>
              </div>
            </td>
          </tr>
          <calendar-row
                  v-if="floor == room.floor" v-for="(room) in rooms"
                  :room-name="room.roomNumber"
                  :room-type="room.roomType.roomType"
                  :room-id="room.roomId"
                  :date-arr="dateArr"
                  :booking-rooms="bookingRooms"
                  :unavailable-rooms="unavailableRooms"
                  @selectSettingRoom="selectSettingRoom"
                  @updateUnavailableRoom="updateUnavailableRoom"
                  @updateCancelRoom="updateCancelBooking"
                  @updateChangeBooking="updateChangeBooking"
                  @updateCheckoutBooking="updateCheckoutBooking"/>
        </template>

        </tbody>
      </table>

    </div>


    <RoomSettingModal :selectedSettingRoom="selectedSettingRoom" :rooms="rooms" @init="init"/>
    <CancelUnavailableModal :unavailableRoom="unavailableRoom" :rooms="rooms" @init="init"/>
    <RoomCalcelModal :selectedCalcelBooking="selectedCalcelBooking" @init="init"/>
    <RoomChangeModal :selectChangeBooking="selectChangeBooking" :rooms="rooms" @init="init" :bookingRooms="bookingRooms" :unavailableRooms="unavailableRooms"/>
    <RoomCheckoutModal :selectedCheckoutBooking="selectedCheckoutBooking" @init="init" />

  </div>
</template>

<script>

import PageHeader from '@/layout/PageHeader.vue';
import DataTable from '@/components/common/DataTable.vue';
import DataTableHeaderColumn from '@/components/common/DataTableHeaderColumn.vue';
import DataTableColumn from '@/components/common/DataTableColumn.vue';
import BookStatusTag from './BookStatusTag';
import CalendarHeader from "./CalendarHeader";
import CalendarRow from "./CalendarRow";
import RoomSettingModal from "./RoomSettingModal";
import CancelUnavailableModal from "./CancelUnavailableModal";
import RoomCalcelModal from "./RoomCalcelModal";
import RoomChangeModal from "./RoomChangeModal";
import RoomCheckoutModal from "./RoomCheckoutModal";


export default {


  components: {PageHeader, DataTable,DataTableHeaderColumn, DataTableColumn, BookStatusTag, CalendarHeader, CalendarRow, RoomSettingModal, CancelUnavailableModal, RoomCalcelModal, RoomChangeModal, RoomCheckoutModal},
  // components: {PageHeader, BookStatusTag},
  data() {
    return {
      component: null,
      fromDate: null,
      toDate: null,
      dateArr : null,
      rooms : null,
      floors: null,
      bookingRooms: null,
      unavailableRooms: null,
      selectedSettingRoom: null,
      unavailableRoom: null,
      selectedCalcelBooking: null,
      selectChangeBooking: null,
      selectedCheckoutBooking: null
    }
  },
  mounted(){
    this.init();
  },
  watch:{

  },
  methods: {
    init(){
      this.getRooms();

      let fromDate = this.$route.query.fromDate;

      if(this.fromDate != null && this.toDate != null){
        this.changeDatePicker('from');
        this.changeDatePicker('to');
      } else if(fromDate && moment.unix(fromDate/1000).toDate() != 'Invalid Date') {
        this.changeDatePicker('query')
      }else{
        this.changeDatePicker('now')
      }
      // this.fromDate = moment(new Date()).startOf('day').toDate();
      // this.toDate = moment(this.fromDate).add(6, 'd').toDate();
      // this.setDateArr();
      // this.getBookingRooms();
    },
    changeDatePicker(type){
      if(type == 'from') this.toDate = moment(this.fromDate).add(6, 'd').toDate();
      else if(type == 'to') this.fromDate = moment(this.toDate).add(-6, 'd').toDate();

      else if(type == 'before') {
        this.fromDate = moment(this.fromDate).add(-7, 'd').toDate();
        this.toDate = moment(this.toDate).add(-7, 'd').toDate();
      }
      else if(type == 'after') {
        this.fromDate = moment(this.fromDate).add(7, 'd').toDate();
        this.toDate = moment(this.toDate).add(7, 'd').toDate();
      }
      else if(type == 'now') {
        this.fromDate = moment(new Date()).startOf('day').toDate();
        this.toDate = moment(this.fromDate).add(6, 'd').toDate();
      }else if(type == 'query') {
        let fromDate = this.$route.query.fromDate;
        this.fromDate = moment.unix(fromDate/1000).toDate();
        this.toDate = moment(this.fromDate).add(6, 'd').toDate();
      }

      this.setDateArr();
      this.getBookingRooms();
      this.getUnavailableRooms();
    },
    setDateArr(){
      this.dateArr = new Array();
      for(let i = this.fromDate ; i <= this.toDate ; i = moment(i).add(1, 'd').toDate()){
        this.dateArr.push(i);
      }
    },
    getThText(date){
      // console.log(moment(date).date() + ' ' + this.getDayTextKorean(moment(date).day()));
      return moment(date).date() + ' ' + this.getDayTextKorean(moment(date).day());
    },
    getDayTextKorean(day){
      if(day == 0) return '일';
      else if(day == 1) return '월';
      else if(day == 2) return '화';
      else if(day == 3) return '수';
      else if(day == 4) return '목';
      else if(day == 5) return '금';
      else if(day == 6) return '토';
      else return '';
    },
    getRooms(){
      this.$http.get('/api/private/booking/rooms')
              .then(function(result) {
                this.rooms = result.data;
                this.rooms.forEach(room => {
                  room.dropdownName = room.roomNumber + " / " + room.roomType.roomType;
                })
                this.floors = result.data.map(room => room.floor).filter((element, index) => result.data.map(room => room.floor).indexOf(element) === index);
              }.bind(this)).catch((e) =>{
              })
    },
    getBookingRooms(){

      let fromDate = moment(this.fromDate).valueOf();
      let toDate = moment(this.toDate).valueOf();
      let url = '/api/private/booking/bookingRooms?fromDate='+fromDate+'&toDate='+toDate;

      console.log(url);

      this.$http.get(url)
              .then((result) => {
                this.bookingRooms = result.data;
              })
    },
    getUnavailableRooms(){
      let fromDate = moment(this.fromDate).valueOf();
      let toDate = moment(this.toDate).valueOf();
      let url = '/api/private/booking/unAvailableRooms?fromDate='+fromDate+'&toDate='+toDate;
      this.$http.get(url)
              .then(function(result) {
                this.unavailableRooms = result.data;
              }.bind(this)).catch((e) =>{
      })
    },

    selectSettingRoom(roomId){
      this.rooms.forEach((room) => {
        if(room.roomId == roomId) this.selectedSettingRoom = room;
      })
    },

    updateUnavailableRoom(unavailableRoom){
      this.unavailableRoom = unavailableRoom;
    },
    updateCancelBooking(booking){
      this.selectedCalcelBooking = booking;
    },
    updateChangeBooking(booking){
      this.selectChangeBooking = booking;
    },
    updateCheckoutBooking(booking){
      this.selectedCheckoutBooking = booking;
    }
  },
}
</script>

<style>

  table.tbl.tbl-type2 th:first-child {
    padding-left: 2px;
  }

  table.tbl.tbl-type2 th {
    border: 1px solid #ededed;
    border-width: 1px 1px 1px 0;
    padding: 6px 2px;
    vertical-align: middle;
    text-align: center;
  }

  table.tbl.tbl-type2 tbody tr:first-child td, table.tbl.tbl-type2 tbody tr:first-child:hover td, table.tbl.tbl-type2 tbody tr:first-child.checked td, table.tbl.tbl-type2 tbody tr:first-child.tr-expand td {
    border-top: 0;
  }

  table.tbl.tbl-type2 td:first-child {
    padding-left: 2px;
  }

  table.tbl.tbl-type2 td {
    position: static;
    border: 1px solid #ededed;
    border-width: 1px 1px 0 0;
    padding: 2px;
    text-align: center;
  }

  table.tbl tr.bg_highlight_type2 td {
    background-color: #ebf0f3;
    border-color: #ededed;
    border-width: 1px 0 0 0;
    border-radius: 0;
  }

  table.tbl tr.bg_highlight_type2 td .td-box {
    font-weight: bold;
    /*text-align: left !important;*/
  }

  table.tbl.tbl-type2 td {
    text-align: left;
  }

  /*tr:hover {*/
  /*  background: #000000;*/
  /*}*/


</style>